import React, {Component} from "react";
import {Avatar, Col, Icon, message, Row, Select, Table, Modal, Form, Button, Popconfirm} from "antd";
import "./main-page.less";
import LineEcharts from "./line-echarts";
import {reqOrderNoteList, reqDelOrderNoteList, reqSaveOrderNoteList, reqUpdateOrderNoteList} from "../../api";
import EditCell, {EditableContext} from "../../components/Editable/edit-cell";
import authorizeBase from "../../components/authorize/authorizeBase";
import LinkButton from '../../components/link-button'
const AuthButton = authorizeBase(Button);

const {Option} = Select;
let recordId;
class WarningModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            page: 1,
            pageSize: 10,
            total: 0,
            nextKey: 0,
            visible: false,
            editingKey: '',
        };
        this.columns = [
            {
                title: '序号',
                dataIndex: 'warningDt',
                width:50,
                render: (text, record, index) => (
                    <span>{index + 1 + (this.state.page - 1) * this.state.pageSize}</span>
                )
            },
            {
                title: '添加人',
                dataIndex: 'userName',
                width:80,
            },
            {
                title: '操作日期',
                dataIndex: 'lastUpdateDt',
                width:140,
            },
            {
                title: '备注',
                dataIndex: 'note',
                editable: true,
                width:200,
            }, {
                title: '操作',
                dataIndex: 'opt',
                width:80,
                render: (text, record) => {
                    let userInfo = window.sessionStorage.getItem("userInfo")
                    if(userInfo) {
                        userInfo = JSON.parse(userInfo)
                    }
                    const {editingKey} = this.state;
                    const editable = this.isEditing(record);
                    if (!record.id || userInfo.username === record.userName) {
                        return editable ? (
                            <span>
                              <EditableContext.Consumer>
                                {form => (
                                    <a onClick={() => this.save(form, record.key)}
                                        style={{marginRight: 8}}>保存</a>
                                )}
                              </EditableContext.Consumer>
                              <Popconfirm title="是否确认取消?" onConfirm={() => this.cancel(record.key)}>
                                <a>取消</a>
                              </Popconfirm>
                            </span>) : (<span>
                                        <a disabled={editingKey !== '' }  style={{marginRight: 8}} onClick={() => this.edit(record.key)}>
                                            编辑
                                        </a>
                                        <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDeleteNote(record.key)}>
                                            <a authority="delivery_edit:car_delete">删除</a>
                                        </Popconfirm></span>
                                        );
                    } else {

                    }
                },

            },
        ];
    }

    isEditing = record => record.key === this.state.editingKey;

    cancel = () => {
        this.setState({editingKey: ''});
    };

    handleAddNote = () => {
        const {nextKey, list} = this.state;
        const newData = {
            key: nextKey,
            recordId: recordId,
            note: ''
        };
        const datasource = [];
        datasource.push(newData)
        list.forEach(function (item) {
            datasource.push(item)
        });
        this.setState({
            list: datasource,
            nextKey: nextKey + 1,
            total: datasource.length
        });
    };

    handleDeleteNote = key => {
        const dataSource = [...this.state.list];
        const index = dataSource.findIndex(item => key === item.key);
        const item = dataSource[index]
        const dataSourceLength = dataSource.length - 1;
        const {page, pageSize} = this.state;
        if (item && item.id) {
            let id = item.id;
            this.getDeleteNote({id});
        } else {
            const dataLength = dataSourceLength % pageSize
            if (dataLength === 0) {
                const totalPage2 = dataSourceLength / pageSize
                if (totalPage2 <= page && page != 1) {
                    this.setState({
                        page: totalPage2
                    })
                }
            }
            this.setState({list: dataSource.filter(item => item.key !== key)});
        }
    };

    // 新增
    getDeleteNote= async (po) => {
        const result = await reqDelOrderNoteList(po);
        if (result.code === 200) {
            this.setState({ editingKey: '', page: 1});
            this.getOrderNoteList({
                pageNum: 1,
                pageSize: this.state.pageSize,
                recordId: recordId,
            });
        } else {
            message.error(result.message);
        }
    };

    // 新增
    getAddNote= async (po) => {
        const result = await reqSaveOrderNoteList(po);
        if (result.code === 201) {
            this.setState({ editingKey: '', page: 1});
            this.getOrderNoteList({
                pageNum: 1,
                pageSize: this.state.pageSize,
                recordId: po.recordId,
            });
        } else {
            message.error(result.message);
        }
    };

    // 更新
    getUpdateNote = async (po) => {
        const result = await reqUpdateOrderNoteList(po);
        if (result.code === 200) {
            this.setState({ editingKey: ''});
            this.getOrderNoteList({
                pageNum: this.state.page,
                pageSize: this.state.pageSize,
                recordId: po.recordId,
            });
        } else {
            message.error(result.message);
        }
    };

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }

            const newData = [...this.state.list];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                // debugger
                const item = newData[index];
                row.id = item.id;
                row.recordId = item.recordId;
                if (row && row.id) {
                    this.getUpdateNote(row)
                } else {
                    this.getAddNote(row)
                }
            } else {
                newData.push(row);
                this.setState({list: newData, editingKey: ''});
            }
        });
    }

    edit(key) {
        this.setState({editingKey: key});
    }

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };
    getOrderNoteList = async (po) => {
        let result = await reqOrderNoteList(po);
        if (result.code === 200) {
            const list = result.data.rows;
            let index = 0;
            list.map(o => {
                o.key = index++;
            });
            this.setState({
                list: list,
                nextKey: result.data.total,
                total: result.data.total,
            })
        } else {
            message.error(result.message)
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.state.visible != nextProps.visible) {
            this.setState({
                visible: nextProps.visible,
                recordId: nextProps.recordId,
                editingKey:''
            });
            if (nextProps.recordId) {
                recordId = nextProps.recordId;
                this.getOrderNoteList({
                    pageNum: this.state.page,
                    pageSize: this.state.pageSize,
                    recordId: nextProps.recordId,
                });
            }
        }
    }


    render() {
        const components = {
            body: {
                cell: EditCell,
            },
        };

        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });
        const {list, page, total, visible} = this.state;

        return (
            <div className='home-page'>
                <Modal
                    title="备注预警信息"
                    width="800px"
                    visible={visible}
                    onCancel={this.handleCancel}
                    footer={null}>
                    <div style={{padding: '0 20px'}}>
                        <AuthButton onClick={this.handleAddNote} type='primary'>新增</AuthButton>
                        <EditableContext.Provider value={this.props.form}>
                            <Table
                                components={components}
                                bordered
                                dataSource={list}
                                columns={columns}
                                rowClassName="editable-row"
                                pagination={{
                                    current: this.state.page,
                                    total: this.state.total,
                                    onChange: (page, pageSize) => {
                                        this.setState({page, pageSize});
                                        this.getOrderNoteList({
                                            pageNum: page,
                                            pageSize: pageSize,
                                            recordId: recordId,
                                        });
                                    }
                                }}
                                size="middle"
                            />
                        </EditableContext.Provider>
                        {/*<Table
                         columns={columns}
                         bordered
                         dataSource={list}
                         rowKey='id'
                         pagination={{
                         current: pageNum,
                         total: total,
                         showQuickJumper: true,
                         onChange: (pageNum, pageSize) => {
                         this.setState({pageNum: pageNum});
                         },
                         }}
                         size="middle"
                         />*/}
                    </div>
                </Modal>

            </div>
        )
    }
}
const WarningModalForm = Form.create()(WarningModal);
export default WarningModalForm